import { Menu, Select } from 'antd';
import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import styled from 'styled-components';

const CustomMenu = styled(Menu)`
  width: 250px;

  .ant-menu-item-selected:after {
    transform: scaleY(1);
    opacity: 1;
    transition: transform 0.15s cubic-bezier(0.645, 0.045, 0.355, 1),
      opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  .ant-menu-item {
    &.ant-menu-item-selected {
      background-color: var(--title-backgournd-grey);
      color: var(--main-web-color);

      ::after {
        left: 0;
        right: auto;
        border-color: var(--main-web-color);
      }
    }

    :not(:last-child) {
      margin-bottom: 0;
    }
  }
`;

const SelectWrapper = styled.div`
  padding: 20px 20px 0 20px;
`;

const SelectLabel = styled.div`
  margin-bottom: 8px;
`;

const CustomSelect = styled(Select)`
  width: 100%;
`;

const PlaceHolder = styled.div`
  width: 250px;
`;

function SelectMenu({
  isDesktop,
  selectedKeys,
  menuItems,
  handleSelectItem,
  selectedKey,
  handleSearch,
}) {
  if (!menuItems?.length) {
    return (
      <PlaceHolder>
        <i>Dữ liệu không tồn tài</i>
      </PlaceHolder>
    );
  }

  return isDesktop ? (
    <Scrollbars style={{ width: 258, height: 700 }}>
      <CustomMenu
        selectedKeys={selectedKeys}
        items={menuItems}
        onSelect={handleSelectItem}
      />
    </Scrollbars>
  ) : (
    <SelectWrapper>
      <SelectLabel>Chọn môn học: </SelectLabel>
      <CustomSelect
        value={selectedKey}
        onChange={handleSelectItem}
        showSearch
        filterOption={handleSearch}
      >
        {menuItems.map(({ key, label }) => (
          <Select.Option value={key} key={key}>
            {label}
          </Select.Option>
        ))}
      </CustomSelect>
    </SelectWrapper>
  );
}

export default SelectMenu;
